export const ORIGINALS_CATEGORY = 'Originals';
